/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const a = ["Th\u1EE9 hai", "Th\u1EE9 ba", "Th\u1EE9 t\u01B0", "Th\u1EE9 n\u0103m", "Th\u1EE9 s\xE1u", "Th\u1EE9 b\u1EA3y", "Ch\u1EE7 nh\u1EADt"], n = ["T2", "T3", "T4", "T5", "T6", "T7", "CN"], e = ["Th\xE1ng 1", "Th\xE1ng 2", "Th\xE1ng 3", "Th\xE1ng 4", "Th\xE1ng 5", "Th\xE1ng 6", "Th\xE1ng 7", "Th\xE1ng 8", "Th\xE1ng 9", "Th\xE1ng 10", "Th\xE1ng 11", "Th\xE1ng 12"], h = "N\u0103m", t = "N\u0103m nay", T = "Th\xE1ng", s = "Tu\u1EA7n", y = "Ng\xE0y", g = "H\xF4m nay", d = "NKh\xF4ng c\xF3 Event", o = "C\u1EA3 ng\xE0y", m = "X\xF3a", r = "T\u1EA1o event", v = "dddd MMMM D YYYY", N = { weekDays: a, weekDaysShort: n, months: e, years: "N\u0103m", year: "N\u0103m nay", month: "Th\xE1ng", week: "Tu\u1EA7n", day: "Ng\xE0y", today: "H\xF4m nay", noEvent: "NKh\xF4ng c\xF3 Event", allDay: "C\u1EA3 ng\xE0y", deleteEvent: "X\xF3a", createEvent: "T\u1EA1o event", dateFormat: "dddd MMMM D YYYY" };
export {
  o as allDay,
  r as createEvent,
  v as dateFormat,
  y as day,
  N as default,
  m as deleteEvent,
  T as month,
  e as months,
  d as noEvent,
  g as today,
  s as week,
  a as weekDays,
  n as weekDaysShort,
  t as year,
  h as years
};
